import './bootstrap';
import 'preline';

import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

var swiper = new Swiper('.swiper', {
    slidesPerView: 6,
    spaceBetween: 10,
    slidesPerGroup: 1,
    freeMode: true,
    paginationClickable: true,
    pagination: {
        el: '.centered-slide-carousel .swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.centered-slide-carousel .swiper-button-next',
        prevEl: '.centered-slide-carousel .swiper-button-prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        550: {
            slidesPerView: 2,
        },
        760: {
            slidesPerView: 3,
        },
    },
});
